export default __webpack_public_path__ + "static/670d1512a8a3666f384128d1570f3e61.jpg";